var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("\n  "+_vm._s(_vm.C('dataIsEmpty'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }